import { Stripe } from 'stripe'
import { StripeEnvironment } from './stripe.interfaces'

export interface BasketDocument {
  basketId: string
  playerId: string
  userId: string
  items: BasketItem[]
}
export interface CheckoutBasketDocument extends BasketDocument {
  pendingOrderCreation: boolean
  pendingOrderCreationAt: number
  environment: StripeEnvironment
  paymentIntent?: string
  paymentStatut?: string
  customer?: string
  checkoutSessionId?: string
}
export interface BasketItem {
  id: string
  productId: string
  variantId: string
  name: string
  price: number
  quantity: number
  currency: string
  converted?: {
    price: number
    currency: string
    rate: number
  }
}
export interface BasketData extends BasketDocument {
  customerId: string | null
}

export type ProductStatus = 'active' | 'inactive' | 'discontinued'
export interface Product {
  id: string
  attributes: ProductAttribute[]
  basePrice: number
  currency: string
  description: string
  featured: boolean
  hasVariants: boolean
  images: ProductImage[]
  mode: 'single' | 'variant'
  name: string
  slug: string
  stock: number
  tags: string[]
  usp: string[]
  variants: ProductVariant[] // never used in database
  status: ProductStatus
  mainImageUrl?: string
  mainImageThumb?: string
  stockOnVariants?: number
}
export interface ProductDocument extends Product {
  createdByUid: string
  createdAt: number
  updatedAt: number
}
export interface ProductVariant {
  id: string
  productId: string
  attributes: ProductAttribute[]
  images: ProductImage[]
  price: number
  stock: number
}
export interface ProductAttribute {
  name: string
  value: string
}
export interface ProductImage {
  id: string
  imageUrl: string
  thumbnail: string
  isMain?: boolean
}
export interface OrderDocument {
  id: string
  userId: string
  playerId: string
  email?: string
  phone?: string
  status: Stripe.Checkout.Session.PaymentStatus
  environment: StripeEnvironment
  currency: string
  totalAmount: number // in minor units (e.g. cents)
  stripeSessionId: string
  stripePaymentIntentId: string
  items: BasketItem[]
  orderType: 'basket' | 'ticket' | 'donation' | 'registration'
  createdAt: number
  updatedAt: number
  transfers: OrderTransfer[]
  stripe?: any
}

export interface OrderTransfer extends Stripe.TransferCreateParams {
  transferId: string
  status: string
}

export interface ProductRating {
  productId: string
  variantId: string
  userId: string
  playerId: string
  rating: number // 0–5
  comment: string
  createdAt: number
  updatedAt: number
}
